import React, { Fragment, useState, useEffect } from 'react';
import {
  Button,
  Input,
  InputGroup,
  InputGroupText,
  InputGroupAddon,
  Spinner,
  Row,
  Label,
  Card,
  CardTitle,
} from 'reactstrap';
import IntlMessages from '../../../../../../../../helpers/IntlMessages';
import Select from 'react-select';
import { useSelector } from 'react-redux';
import 'react-quill/dist/quill.bubble.css';
import { Separator, Colxx } from '../../../../../../../../components/common/CustomBootstrap';
import {
  AxiosAPI,
  getGroupID,
} from '../../../../../../../../helpers/AxiosAPI';
import {
  gAPI_Twilio_Templates,
  postAPI_GuestMessagingReservation_SendMessage
} from '../../../../../../../../constants/APIs';
import { NotificationManager } from '../../../../../../../../components/common/react-notifications';
import countryCodes from '../../../../../../../../data/dial_code';
import moment from 'moment';

const STATUS_OPTIONS = [
  { label: 'In House', value: 'InHouse' },
  { label: 'Arrived Today', value: 'ArrivedToday' },
  { label: 'Arrived Yesterday', value: 'ArrivedYesterday' },
  { label: 'Departing Today', value: 'DepartingToday' },
  { label: 'Departing Tomorrow', value: 'DepartingTomorrow' },
  { label: 'Departed Today', value: 'DepartedToday' },
  { label: 'Departed Yesterday', value: 'DepartedYesterday' },
];
const formatDate = (date) => (date ? moment(date).format('YYYY-MM-DD') : null);
const PLACEHOLDER_VALUE_MAP = {
  guest_first_name: (r) => r?.firstName || '',
  guest_last_name: (r) => r?.lastName || '',
  guest_phone: (r) => r?.phone || '',
  guest_email: (r) => r?.email || '',
  room_number: (r) => r?.roomNumber || '',
  room_type: (r) => r?.roomTypeName || '',
  check_in_date: (r) => formatDate(r?.arrivalDate || ''),
  check_out_date: (r) => formatDate(r?.departureDate || ''),
};

const BULK_LABEL_MAP = {
  guest_first_name: 'First Name',
  guest_last_name: 'Last Name',
  guest_phone: 'Phone Number',
  guest_email: 'Email Address',
  room_number: 'Room Number',
  room_type: 'Room Type',

  check_in_date: 'Arrival Date',
  check_out_date: 'Departure Date',
};




const styles = `
      .ql-toolbar {  
        border: 1px solid #ccc !important;            
         border-radius: 0px!important;  
         background:white;       
      }

      .ql-container{
        border: 1px solid #ccc !important; 
        border-radius: 0px!important;   
        background:white;      
      }
      
      .dropzone {
        min-height: 40px !important;
        cursor:pointer;
    }
  `;

const WhatsApptab = ({
  propertyId,
  preFillPhoneNumber,
  showStatusFilter = false,
  showPhoneNumber = false,
  reservationId,
  source,
  onStatusChange,
  totalCount,
  loadingCount,
  reservationData
}) => {
  const { userName, timeZone } = useSelector(({ settings }) => ({
    userName: settings.userName,
    timeZone: settings.timeZone,
  }));

  const [templateList, setTemplateList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [statusMessage, setStatusMessage] = useState({ text: '', type: '' });
  const [whatsAppData, setwhatsAppData] = useState({
    templateId: '',
    to: '',
    countryCode: '+64',
    rawNumber: preFillPhoneNumber || '',
    text: '',
  });

  useEffect(() => {
    if (statusMessage.text) {
      const timer = setTimeout(() => {
        setStatusMessage({ text: '', type: '' });
      }, 10000);
      return () => clearTimeout(timer);
    }
  }, [statusMessage]);

  useEffect(() => {
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Twilio_Templates}?group_id=${getGroupID()}&property_id=${propertyId}`,
    }).then((res) => {
      setTemplateList(res.data);
      if (preFillPhoneNumber !== undefined && preFillPhoneNumber != null) {
        let raw = preFillPhoneNumber || '';
        let dialCode = '+64';
        countryCodes.map((m) => {
          if (raw.startsWith(m.dial_code)) {
            raw = raw.replace(m.dial_code, '');
            dialCode = m.dial_code;
          }
        });
        setwhatsAppData((prev) => ({
          ...prev,
          rawNumber: raw,
          countryCode: dialCode,
          to: `${dialCode}${raw}`,
        }));
      }
    });
  }, [propertyId, preFillPhoneNumber]);

  const handleTemplate = (e) => {
    const selectedTemplate = templateList.find(
      (t) => t.templateId === e.target.value
    );
    if (!selectedTemplate) return;
    const text = selectedTemplate.templateBody || '';

    const placeholders = (selectedTemplate.placeholders || []).map((ph) => {
      const placeholderKey = `{{${ph.name}}}`;

      // Manual → auto-fill
      // Bulk   → empty (backend will resolve)
      const value =
        source === 'Manually'
          ? PLACEHOLDER_VALUE_MAP[ph.value]?.(reservationData) || ''
          : '';

      return {
        key: placeholderKey,
        sourceKey: ph.value, // guest_first_name, check_in_date etc
        label:
          BULK_LABEL_MAP[ph.value] ||
          ph.value.replaceAll('_', ' ').toUpperCase(),
        value,
      };
    });

    setwhatsAppData((prev) => ({
      ...prev,
      templateId: selectedTemplate.templateId,
      text,
      placeholders,
    }));
  };


  const handlePlaceHolders = (value, index) => {
    let placeholders = [...whatsAppData.placeholders];
    placeholders[index].value = value;
    setwhatsAppData({ ...whatsAppData, placeholders: placeholders });
  };

  const sendWhatsAppMessage = async () => {
    if (
      !whatsAppData.placeholders ||
      !Array.isArray(whatsAppData.placeholders) ||
      whatsAppData.placeholders.length === 0
    ) {
      NotificationManager.error(
        '',
        'No placeholders found for selected template.',
        3000
      );
      return;
    }
    let templateData = {};
    let placeholders = [...whatsAppData.placeholders];
    if (
      source === 'Bulk' ||
      placeholders.filter((f) => f.value === '').length === 0
    ) {

      placeholders.forEach((m) => {
        const key = m.key.replaceAll('{', '').replaceAll('}', '');
        templateData[key] =
          source === 'Bulk'
            ? m.sourceKey
            : m.value;
      });
      let payload = {
        groupId: getGroupID(),
        propertyId,
        channel: 'Whatsapp',
        templateId: whatsAppData.templateId,
        message: whatsAppData.text,
        placeholderValues: templateData,
        CreatedBy: userName,
      };

      if (source === 'Manually') {
        payload = {
          ...payload,
          reservationId,
          MobileNumber: whatsAppData.to,
          StatusFilter: 'Individual',
        };
        console.log("pay", payload)
      }

      if (source === 'Bulk') {
        if (!selectedStatus) {
          NotificationManager.error(
            '',
            'Please select a status before sending message.',
            3000
          );
          return;
        }
        payload = {
          ...payload,
          timeZone,
          StatusFilter: selectedStatus.value,
        };
      }


      try {
        setLoading(true);

        const res = await AxiosAPI({
          method: 'post',
          url: postAPI_GuestMessagingReservation_SendMessage,
          data: payload,
        });

        const backendMsg =
          typeof res?.data === 'string'
            ? res.data
            : res?.data?.statusMessage ||
            res?.data?.message ||
            'Message sent';


        if (source === 'Manually') {
          setStatusMessage({
            text: backendMsg,
            type: 'success',
          });
        }
        else {
          setStatusMessage({
            text: backendMsg,
            type: 'success',
          });

        }
      } catch (error) {
        console.error(error);

        const backendError =
          typeof error?.response?.data === 'string'
            ? error.response.data
            : error?.response?.data?.statusMessage ||
            error?.response?.data?.message ||
            'Failed to send SMS message.';

        if (source === 'Manually') {
          setStatusMessage({
            text: backendError,
            type: 'error',
          });
        }
        else {
          setStatusMessage({
            text: 'Message Failed',
            type: 'error',
          })
        }
      } finally {
        setLoading(false);
      }
    }
  }
  const isUSNumber = whatsAppData?.countryCode === '+1';

  const renderBulkStatus = (msg) => {
    if (!msg) return null;

    // Only format when queued info exists
    if (!msg.toLowerCase().includes("queued")) {
      return msg;
    }

    // Split on both "|" and "," safely
    const parts = msg
      .split(/[\|,]/)
      .map(p => p.trim())
      .filter(p => p !== "");

    const formatPart = (part, color) => {
      if (!part.includes(":")) return part;

      const [label, value] = part.split(":");

      const cleanLabel =
        label.trim().charAt(0).toUpperCase() +
        label.trim().slice(1).toLowerCase();

      const cleanValue = value?.trim();

      return (
        <span style={{ color, fontWeight: 600 }}>
          {cleanLabel}
          {cleanValue ? `: ${cleanValue}` : ""}
        </span>
      );
    };

    const header = parts[0]; // Bulk messages processed
    const queuedPart = formatPart(parts[1], "green");
    const failedPart = formatPart(parts[2], "red");

    return (
      <span>
        {header}{" "}
        {queuedPart && <>| {queuedPart} </>}
        {failedPart && <>| {failedPart}</>}
      </span>
    );
  };

  const renderManualStatus = (msg) => {
    if (!msg) return null;

    const normalized = msg.trim().toLowerCase();

    const formatted =
      normalized.charAt(0).toUpperCase() + normalized.slice(1);

    const isQueued = normalized.includes('queued');

    return (
      <span
        style={{
          color: isQueued ? 'green' : 'red',
          fontWeight: 600,
        }}
      >
        {formatted}
      </span>
    );
  };


  return (
    <Fragment>
      <Card className=" mt-2 " style={{ boxShadow: "none" }}>
        <CardTitle className="ml-3">
          <IntlMessages id="content.sendwhatsapp" />{' '}
        </CardTitle>

        <style>{styles}</style>
        <Row className="ml-2 mr-2">
          {showStatusFilter && source === 'Bulk' && (
            <Colxx md="12" className="mb-2">
              <Label>Select status</Label>
              <Select
                className="react-select"
                classNamePrefix="react-select"
                options={STATUS_OPTIONS}
                placeholder="Select status"
                value={selectedStatus}

                onChange={(val) => {
                  setSelectedStatus(val);
                  if (val && onStatusChange) {
                    onStatusChange(val.value);
                  }
                }}
                isClearable
              />

              {source === 'Bulk' && selectedStatus && (
                <div className="mt-1" style={{ fontSize: '13px' }}>
                  {loadingCount ? (
                    'Fetching guest count...'
                  ) : (
                    <b>Message will be sent to {totalCount} guests with mobile number available</b>
                  )}
                </div>
              )}

            </Colxx>
          )}


          <Colxx md="12" className="mb-2">
            <Label>Template</Label>
            <Input
              type="select"
              name="Template"
              onChange={handleTemplate}
            >
              <option value="">Please Select</option>

              {Array.isArray(templateList) &&
                templateList
                  .filter(
                    (t) =>
                      Array.isArray(t.channel) &&
                      t.channel.some(
                        (c) => c && c.toLowerCase() === 'whatsapp'
                      )
                  )
                  .map((m) => (
                    <option key={m.templateId} value={m.templateId}>
                      {m.name}
                    </option>
                  ))}
            </Input>

          </Colxx>
          {whatsAppData?.templateId && whatsAppData?.templateId !== '' ? (
            <Fragment>
              {loading ? (
                <div className="text-center">
                  <Spinner color="primary" className="mb-1" />
                </div>
              ) : (
                <Fragment>
                  <Colxx md="12" className="mb-2">
                    <Label>Message</Label>
                    <Input
                      type="textarea"
                      value={whatsAppData?.text}
                      name="conditions"
                      disabled={true}
                    // onChange={handleChangeConditionsArr}
                    />
                  </Colxx>

                  {whatsAppData.placeholders?.map((ph, index) => (
                    <Colxx md="12" className="mb-2" key={index}>
                      <Label>
                        Add Placeholder Value
                      </Label>

                      <InputGroup>
                        <InputGroupAddon>
                          <InputGroupText style={{ width: '150px' }}>{ph.key}</InputGroupText>
                        </InputGroupAddon>

                        <Input
                          type="text"
                          value={source === 'Bulk' ? ph.label : ph.value}
                          disabled={source === 'Bulk'}
                          onChange={(e) =>
                            source !== 'Bulk' &&
                            handlePlaceHolders(e.target.value, index)
                          }
                        />
                      </InputGroup>
                    </Colxx>
                  ))}

                  {showPhoneNumber && (
                    <Colxx md="12" className="mb-2">
                      <Label>Mobile Number</Label>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <Input
                            type="select"
                            name="countryCode"
                            value={whatsAppData.countryCode || '+64'}
                            onChange={(e) =>
                              setwhatsAppData({
                                ...whatsAppData,
                                countryCode: e.target.value,
                                to: `${e.target.value}${whatsAppData.rawNumber || ''
                                  }`,
                              })
                            }
                            style={{
                              width: '200px',
                              textAlign: 'center',
                              cursor: 'pointer',
                            }}
                          >
                            {countryCodes.map((c) => (
                              <option key={c.code} value={c.dial_code}>
                                {c.code} {c.dial_code} ({c.name})
                              </option>
                            ))}
                          </Input>
                        </InputGroupAddon>
                        <Input
                          type="text"
                          placeholder="Enter phone number"
                          value={whatsAppData.rawNumber || ''}
                          disabled={isUSNumber}
                          style={{
                            backgroundColor: isUSNumber ? '#e9ecef' : 'white',
                            cursor: isUSNumber ? 'not-allowed' : 'text',
                          }}
                          onChange={(e) => {
                            if (isUSNumber) return;
                            const number = e.target.value.replace(/\D/g, '');
                            setwhatsAppData({
                              ...whatsAppData,
                              rawNumber: number,
                              to: `${whatsAppData.countryCode || '+64'}${number}`,
                            });
                          }}
                        />
                      </InputGroup>
                      {isUSNumber && (
                        <div
                          style={{
                            color: 'black',
                            fontSize: '12px',
                            marginTop: '5px',
                          }}
                        >
                          <b>
                            {' '}
                            WhatsApp business messages are not being sent to U.S.
                            numbers because Meta paused all marketing messages to
                            U.S. numbers on April 1, 2025.
                          </b>
                        </div>
                      )}
                    </Colxx>
                  )}
                </Fragment>
              )}
            </Fragment>
          ) : null}
        </Row>
        <div className="text-center my-3">
          {statusMessage.text && (
            <div className="mb-2 font-medium">
              <b>
                {source === 'Bulk'
                  ? renderBulkStatus(statusMessage.text)
                  : renderManualStatus(statusMessage.text)}
              </b>
            </div>
          )}

          {whatsAppData?.templateId && whatsAppData?.templateId !== '' ? (
            <>
              <Separator className="mb-3" />
              <Button
                color="primary"
                size="sm"
                onClick={sendWhatsAppMessage}
                disabled={isUSNumber}
              >
                Send
              </Button>
            </>
          ) : null}
          {/* <Button className='ml-2' color="secondary" size="xs" onClick={toggle}>
            Cancel
          </Button> */}
        </div>
      </Card>
    </Fragment>
  );
};

export default WhatsApptab;




